import moment from "moment";

class watchesEmp {
  constructor(empId, relojId, nomReloj, descReloj, fecDesde, fecHasta) {
    this.empId = empId;
    this.relojId = relojId;
    this.nombre = nomReloj;
    this.descripcion = descReloj ? descReloj : "";
    this.from = moment(fecDesde).utc().format("DD-MM-YYYY");
    this.to = fecHasta ? moment.utc(fecHasta).format("DD-MM-YYYY") : " ";
  }

  static fromJson({ empId, relojId, nomReloj, descReloj, fecDesde, fecHasta }) {
    return new watchesEmp(
      empId,
      relojId,
      nomReloj,
      descReloj,
      fecDesde,
      fecHasta
    );
  }
}

export default watchesEmp;
